import { Controller } from "@hotwired/stimulus";
import Quill from "quill";

export default class extends Controller {
    static targets = ["editor", "hidden"];

    declare readonly editorTarget: HTMLElement;
    declare readonly hiddenTarget: HTMLInputElement;

    private quill: Quill | null = null;

    connect() {
        // Configure Quill options as desired.
        const options = {
            theme: "snow",
            modules: {
                toolbar: [
                    [{ header: [1, 2, false] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["clean"]
                ]
            }
        };

        // Initialize Quill on the editor target.
        this.quill = new Quill(this.editorTarget, options);
        // this.quill.root.innerHTML = this.hiddenTarget.value;
        const delta = this.quill.clipboard.convert({ html: this.hiddenTarget.value });
        this.quill.setContents(delta);
        this.quill.update('silent');

        // Update the hidden field when Quill content changes.
        this.quill.on("text-change", () => {
            this.hiddenTarget.value = this.quill?.root.innerHTML || '';
        });
    }

    disconnect() {
        // There is no direct destruction method for Quill,
        // but you may manually clear event listeners or remove the editor's DOM if needed.
        // For now, we simply remove the editor container's innerHTML.
        if (this.quill) {
            this.quill.off('text-change');
            // Additional cleanup if you have custom event listeners
            this.editorTarget.innerHTML = "";
            console.log("Quill editor disconnected.");
        }
    }
}